import React from 'react';
import './liensConsultation.css';

/**
 * Liens externes de la consultation en cours.
 *
 * Source unique : la page Publications ET l'onglet « Avis et documents » de la
 * candidature les lisent ici. A chaque nouvelle consultation, c'est CE fichier
 * seul qui change.
 *
 * Le separateur de parametres des URL AWS est un '&' brut. La source d'ou elles
 * sont recopiees (code HTML d'une page) l'echappe en '&amp;' : colle tel quel, le
 * navigateur lit un parametre nomme 'amp;IDM' et AWS ne trouve pas la consultation.
 *
 * LIMITE CONNUE : ces liens designent UNE consultation et s'affichent sur toutes
 * les lignes du tableau. Aujourd'hui la base n'en porte qu'une, donc le cas ne se
 * presente pas. Le jour ou une deuxieme s'ouvre (AccordCadreController::index
 * liste tous les AC en ouvert/configure/ferme/phase_2, donc les deux lignes
 * s'afficheront), il faudra indexer ces liens par `ref_avis` sous peine de faire
 * pointer l'ancienne ligne vers l'avis de la nouvelle. Voir la note dans mep/MEP.md.
 */

// Profil acheteur et questions/reponses partagent la meme URL aujourd'hui. Deux
// constantes distinctes malgre tout : si AWS les separe un jour, on change celle
// qui bouge sans avoir a demeler un alias.
export const LIEN_AAPC_JOUE =
  'https://ted.europa.eu/fr/notice/-/detail/451413-2026';

export const LIEN_AAPC_BOAMP =
  'https://www.boamp.fr/pages/avis/?q=idweb:26-64393';

export const LIEN_PROFIL_ACHETEUR_AWS =
  'https://www.marches-publics.info/mpiaws/index.cfm?fuseaction=dematEnt.choixDCE&IDM=1825660&XFAOK=dce.verifLotsDCE';

export const LIEN_QUESTIONS_REPONSES_AWS =
  'https://www.marches-publics.info/mpiaws/index.cfm?fuseaction=dematEnt.choixDCE&IDM=1825660&XFAOK=dce.verifLotsDCE';

export interface LienConsultation {
  cle: string;
  libelle: string;
  url: string;
}

/** Les quatre liens, dans l'ordre d'affichage voulu par le metier. */
export const LIENS_CONSULTATION: LienConsultation[] = [
  { cle: 'joue', libelle: "Lien vers l'AAPC (JOUE)", url: LIEN_AAPC_JOUE },
  { cle: 'boamp', libelle: "Lien vers l'AAPC (BOAMP)", url: LIEN_AAPC_BOAMP },
  { cle: 'aws-profil', libelle: 'Lien vers le profil acheteur (AWS)', url: LIEN_PROFIL_ACHETEUR_AWS },
  {
    cle: 'aws-questions',
    libelle: 'Lien vers les questions/réponses sur le profil acheteur (AWS)',
    url: LIEN_QUESTIONS_REPONSES_AWS,
  },
];

/**
 * Rend un libelle en lien externe quand l'URL est renseignee, en texte simple sinon.
 *
 * stopPropagation : dans le tableau des publications, la ligne ouvre la modale de
 * detail ; le clic sur le lien ne doit pas la declencher en plus de la navigation.
 *
 * Le repli est un <span>, jamais un fragment : deux fragments freres dans un
 * conteneur flex fusionnent en un seul element anonyme, ce qui recollerait JOUE et
 * BOAMP sur la meme ligne des qu'une URL est vide.
 */
export const LienExterne: React.FC<{ href: string; label: string }> = ({ href, label }) => (
  href
    ? (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="lien-externe"
        onClick={(e) => e.stopPropagation()}
      >
        {label}
      </a>
    )
    : <span className="lien-externe-inactif">{label}</span>
);

/** Bloc des quatre liens, place en tete d'une section « Avis de marché ». */
export const BlocLiensConsultation: React.FC = () => (
  <ul className="liens-consultation">
    {LIENS_CONSULTATION.map((lien) => (
      <li key={lien.cle} className="liens-consultation__item">
        <span className="liens-consultation__libelle">{lien.libelle} : </span>
        <LienExterne href={lien.url} label={lien.url} />
      </li>
    ))}
  </ul>
);
